import { useCallback, useState, useRef, useEffect } from 'react';
import style from './style.module.scss';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import Slct from '../Slct';
import Button from '../Button';
import moment from "moment";
import DayView from './views/DayView';
import ListView from './views/ListView';
import AgendaIco from '../Svg/new/agenda';
import Loading from '../Loading';
import IcSetaDireita from "../Svg/IcSetaDireita";
import IcSetaEsquerda from "../Svg/IcSetaEsquerda";
import useWrapper from '../../hooks/useWrapper';
import { ModalConfirm } from '../Modal';
import api from '../../services/api';
import { toast } from 'react-toastify';
import printRules from "../PrintRules/style.module.scss";
import { PrintPage } from "../PrintPage";

import 'react-big-calendar/lib/css/react-big-calendar.css';
require('moment/locale/pt.js');

export default function CalendarBig(props) {

  const localizer = momentLocalizer(moment);
  const { events, onSelectEvent, reload, setreload, loading, commercial_id, commercial_name, is_trainee, can_print } = props;
  const { me, config } = useWrapper();
  const permissions = JSON.parse(me?.permissions || "{}");
  const [date, setdate] = useState(new Date());
  const [view, setview] = useState("month");

  const eventPropGetter = useCallback(
    (event, start, end, isSelected) => ({
      ...(event.status === "foreseen" && {
        className: 'Prevista',
      }),
      ...(event.status === "confirmed" && {
        className: 'Confirmada',
      }),
      ...(!!event.done && {
        className: 'Concluída',
      }),
      ...(event.status === "concluded" && {
        className: 'Concluída',
      }),
      ...(event.status === "pending" && {
        className: 'Atrasada',
      }),
    }),
    []
  )

  const changeMonth = __move => {
    let _day = new Date(date);
    _day.setMonth(_day.getMonth() + __move);
    setdate(_day);
    setview("month");
  }

  let _years = [];
  for (let i = 2000; i < 2100; i++) {
    _years.push({ value: i, label: i })
  }

  const [recalculation, setrecalculation] = useState();
  const confirmRecalculation = async () => {
    try {
      await api.post("recalcu-calendar", { commercial_id: commercial_id }, config);
      await api.post("activity", {
        message: `Tarefas foram recalculadas`,
        user_id: me.id,
        commercial_id: commercial_id,
        type: 'act'
      }, config);
      setrecalculation(false);
      toast.success('Tarefas recalculadas com sucesso!');
      setreload(!reload);
    }
    catch (__err) {
      console.log('__err', __err)
    }
  };

  // onSelectSlot Stuff
  const clickRef = useRef(null);
  useEffect(() => {
    return () => {
      window.clearTimeout(clickRef?.current)
    }
  }, [])

  const onSelectSlot = useCallback(slotInfo => {
    if (me?.type === "Formando") {
      window.clearTimeout(clickRef?.current)
      setdate(slotInfo.start);
      setview("custom_day");
    }
  }, [])

  return (
    <PrintPage
      has_logo={true}
      header={<>
        <h2 style={{ fontSize: "2em", color: "var(--color-primary)" }}>Calendário</h2>
        <h2 style={{ fontSize: "1.5em" }}>{commercial_name || ""}</h2>
      </>}
    >
      <div className={`${me?.type === "Gestor" ? style.calendar_gestor : style.calendar_formando}`}>
        <div className={`${style.calendar_header} ${printRules.hide_on_print}`}>
          <div className={style.filters}>
            {(
              view === "list_view" &&
              me?.type === "Gestor" &&
              !!can_print
            ) && (
                <Button
                  color="primary"
                  className="px-2 py-1"
                  onClick={() => {
                    window.print();
                  }}
                >
                  Imprimir
                </Button>
              )}
            {view !== "month" ? (
              <Button
                color="primary"
                className="px-2 py-1"
                onClick={() => {
                  setview("month");
                }}
              >
                <AgendaIco />
                <span className="mr-2"></span>
                Voltar
              </Button>
            ) : (
              <>
                <Button
                  color="primary_ghost"
                  className="px-2 py-1"
                  onClick={() => {
                    changeMonth(-1);
                  }}
                >
                  <IcSetaEsquerda />
                </Button>

                <Slct
                  value={date.getMonth()}
                  sortBy="value"
                  options={[
                    { value: 0, label: "Janeiro" },
                    { value: 1, label: "Fevereiro" },
                    { value: 2, label: "Março" },
                    { value: 3, label: "Abril" },
                    { value: 4, label: "Maio" },
                    { value: 5, label: "Junho" },
                    { value: 6, label: "Julho" },
                    { value: 7, label: "Agosto" },
                    { value: 8, label: "Setembro" },
                    { value: 9, label: "Outubro" },
                    { value: 10, label: "Novembro" },
                    { value: 11, label: "Dezembro" }
                  ]}
                  placeholder="..."
                  onChange={__ev => {
                    let _day = new Date(date);
                    _day.setMonth(__ev.value);
                    setdate(_day);
                    setview("month");
                  }}
                  className={style.select_month}
                />
                <Slct
                  value={date.getFullYear()}
                  sortBy="value"
                  options={_years}
                  placeholder="..."
                  onChange={__ev => {
                    let _day = new Date(date);
                    _day.setFullYear(__ev.value);
                    setdate(_day);
                    setview("month");
                  }}
                  className={style.select_year}
                />

                <Button
                  color="primary_ghost"
                  className="px-2 py-1"
                  onClick={() => {
                    changeMonth(1)
                  }}
                >
                  <IcSetaDireita />
                </Button>


                <Button
                  onClick={() => {
                    setview("list_view");
                  }}
                >
                  Lista
                </Button>

              </>
            )}
          </div>
          <div className={style.filters}>
            {(!!permissions?.calendar?.recalc && commercial_id) && (
              <Button
                color="primary_ghost"
                onClick={() => {
                  setrecalculation(true)
                }}
              >
                Recalcular
              </Button>
            )}
            {!!permissions?.calendar?.createForClass && (
              <Button
                color="primary"
                onClick={() => {
                  onSelectEvent("")
                }}
              >
                Nova Tarefa
              </Button>
            )}
          </div>
        </div>
        <ModalConfirm
          show={recalculation}
          title="Recalcular Tarefas"
          text="Tem certeza que deseja recalcular as tarefas desta Turma? Essa ação é irreversível!"
          confirm={confirmRecalculation}
          closeModal={() => {
            setrecalculation(false);
          }}
          colorScheme="primary"
          confirmText="Recalcular"
        />
        {!loading ? (
          <Calendar
            localizer={localizer}
            startAccessor="start"
            endAccessor="end"
            eventPropGetter={eventPropGetter}
            events={events || []}
            onSelectEvent={onSelectEvent}
            onNavigate={__ev => {
              setview("custom_day");
              setdate(__ev);
            }}
            onSelectSlot={onSelectSlot}
            culture={"pt-BR"}
            messages={{
              week: 'Semana',
              work_week: 'Dia de Semana',
              day: 'Dia',
              month: 'Mês',
              previous: 'Anterior',
              next: 'Próximo',
              today: 'Hoje',
              agenda: 'Agenda',
              showMore: (total) => `+${total} tarefas`,
            }}
            view={view}
            views={{
              month: true,
              custom_day: DayView,
              list_view: ListView
            }}
            date={date}
            reload={reload}
            setreload={setreload}
            is_trainee={is_trainee}
            selectable
          />
        ) : (
          <Loading />
        )}
      </div>
    </PrintPage>
  )
}